export interface SuggestionItem {
  id: string;
  label: string;
  agent: 'hr' | 'recruitment' | 'project';
}

export const SUGGESTIONS: SuggestionItem[] = [
  {
    id: 'hr-leave-balance',
    label: 'Check my leave balance',
    agent: 'hr',
  },
  { id: 'hr-list-employees', label: 'List all employees', agent: 'hr' },
  {
    id: 'hr-list-employees-by-department',
    label: 'List employees by department',
    agent: 'hr',
  },
  {
    id: 'hr-list-active-employees',
    label: 'List active employees',
    agent: 'hr',
  },
  {
    id: 'hr-list-inactive-employees',
    label: 'List inactive employees',
    agent: 'hr',
  },
  { id: 'hr-search-employee', label: 'Search for an employee', agent: 'hr' },

  // ── getAttendanceTool ────────────────────────────────────
  {
    id: 'hr-list-attendance-company',
    label: 'List company-wide attendance summary',
    agent: 'hr',
  },
  {
    id: 'hr-list-attendance-employee',
    label: "List an employee's attendance records",
    agent: 'hr',
  },
  {
    id: 'hr-list-my-attendance',
    label: 'List my attendance records',
    agent: 'hr',
  },

  // ── getRegulariseRequestsTool ────────────────────────────
  {
    id: 'hr-list-regularise-requests',
    label: 'List regularisation requests',
    agent: 'hr',
  },
  {
    id: 'hr-list-my-regularise-requests',
    label: 'List my regularisation requests',
    agent: 'hr',
  },
  {
    id: 'hr-list-pending-regularise',
    label: 'List pending regularisation requests',
    agent: 'hr',
  },

  // ── getLeaveRequestsTool ─────────────────────────────────
  {
    id: 'hr-list-leave-requests',
    label: 'List all leave requests',
    agent: 'hr',
  },
  {
    id: 'hr-list-my-leave-requests',
    label: 'List my leave requests',
    agent: 'hr',
  },
  {
    id: 'hr-list-pending-leave',
    label: 'List pending leave requests',
    agent: 'hr',
  },
  {
    id: 'hr-list-on-leave-today',
    label: 'List who is on leave today',
    agent: 'hr',
  },

  // ── getSlackActivityTool ──────────────────────────────────
  {
    id: 'hr-list-slack-activity',
    label: 'List employee Slack activity',
    agent: 'hr',
  },
  {
    id: 'hr-list-most-active-slack',
    label: 'List most active Slack users',
    agent: 'hr',
  },
  {
    id: 'hr-list-least-active-slack',
    label: 'List least active Slack users',
    agent: 'hr',
  },

  // ── getEventsTool ─────────────────────────────────────────
  { id: 'hr-list-events', label: 'List company events', agent: 'hr' },
  { id: 'hr-list-holidays', label: 'List holidays', agent: 'hr' },
  { id: 'hr-list-birthdays', label: 'List upcoming birthdays', agent: 'hr' },
  { id: 'hr-list-my-events', label: 'List my events', agent: 'hr' },

  // ── searchPolicyDocumentsTool / listCompanyPolicyDocumentsTool ─
  {
    id: 'hr-list-policy-documents',
    label: 'List all policy documents',
    agent: 'hr',
  },
  {
    id: 'hr-search-policy-documents',
    label: 'Search policy documents',
    agent: 'hr',
  },

  // ── getCompanyRecordsTool: grievance ──────────────────────
  { id: 'hr-list-grievances', label: 'List all grievances', agent: 'hr' },
  { id: 'hr-list-my-grievances', label: 'List my grievances', agent: 'hr' },
  { id: 'hr-list-open-grievances', label: 'List open grievances', agent: 'hr' },
  {
    id: 'hr-list-critical-grievances',
    label: 'List critical grievances',
    agent: 'hr',
  },

  // ── getCompanyRecordsTool: editRequest ────────────────────
  {
    id: 'hr-list-edit-requests',
    label: 'List profile edit requests',
    agent: 'hr',
  },
  {
    id: 'hr-list-pending-edit-requests',
    label: 'List pending edit requests',
    agent: 'hr',
  },
  {
    id: 'hr-list-high-risk-edit-requests',
    label: 'List high-risk edit requests',
    agent: 'hr',
  },

  // ── getCompanyRecordsTool: notification ───────────────────
  { id: 'hr-list-notifications', label: 'List my notifications', agent: 'hr' },
  {
    id: 'hr-list-unread-notifications',
    label: 'List unread notifications',
    agent: 'hr',
  },

  // ── getBillingTool ─────────────────────────────────────────
  { id: 'hr-list-plans', label: 'List subscription plans', agent: 'hr' },
  {
    id: 'hr-list-subscriptions',
    label: 'List subscription history',
    agent: 'hr',
  },

  // ── getPerformanceSummaryTool ────────────────────────────
  {
    id: 'hr-list-performance',
    label: 'List employee performance scores',
    agent: 'hr',
  },
  { id: 'hr-list-top-performers', label: 'List top performers', agent: 'hr' },
  {
    id: 'hr-list-bottom-performers',
    label: 'List lowest performers',
    agent: 'hr',
  },
  {
    id: 'hr-list-performance-by-department',
    label: 'List performance by department',
    agent: 'hr',
  },

  // ── getOnboardingStatusTool ───────────────────────────────
  {
    id: 'hr-list-my-onboarding-checklist',
    label: 'List my onboarding checklist',
    agent: 'hr',
  },
  {
    id: 'hr-list-onboarding-checklist',
    label: "List a new hire's onboarding checklist",
    agent: 'hr',
  },

  // ── listCompanyPolicyDocumentsTool (dedicated inventory) ──
  {
    id: 'hr-list-all-policy-docs-inventory',
    label: 'List full policy document inventory',
    agent: 'hr',
  },

  // ── exportAttendanceTool ──────────────────────────────────
  {
    id: 'hr-list-attendance-export',
    label: 'List attendance for export',
    agent: 'hr',
  },
  {
    id: 'hr-list-my-attendance-export',
    label: 'List my attendance for export',
    agent: 'hr',
  },

  // ── getRolesAndPermissionsTool ────────────────────────────
  { id: 'hr-list-roles', label: 'List all roles', agent: 'hr' },
  {
    id: 'hr-list-permissions-by-role',
    label: 'List permissions for a role',
    agent: 'hr',
  },

  // ── getIntegrationsStatusTool ──────────────────────────────
  {
    id: 'hr-list-integrations',
    label: 'List connected integrations',
    agent: 'hr',
  },

  // ── getGoogleDriveFoldersTool ──────────────────────────────
  {
    id: 'hr-list-drive-folders',
    label: 'List Google Drive folders',
    agent: 'hr',
  },

  // ── getDeletionRequestsTool ────────────────────────────────
  {
    id: 'hr-list-deletion-requests',
    label: 'List data deletion requests',
    agent: 'hr',
  },
  {
    id: 'hr-list-pending-deletion-requests',
    label: 'List pending deletion requests',
    agent: 'hr',
  },

  // ── getEmployeeDocumentsTool ───────────────────────────────
  {
    id: 'hr-list-my-documents',
    label: 'List my uploaded documents',
    agent: 'hr',
  },
  {
    id: 'hr-list-employee-documents',
    label: "List an employee's documents",
    agent: 'hr',
  },

  // ── getEmployeeProfileTool (not a list, single record — noted below) ──
  // Not included: single-record lookup, not a "list"

  // ── getEmployeeProductivityTool (not a list, single-employee summary) ──
  // Not included: single-record summary, not a "list"

  {
    id: 'hr-attendance',
    label: 'View my attendance',
    agent: 'hr',
  },
  {
    id: 'hr-leave-requests',
    label: 'Show leave requests',
    agent: 'hr',
  },
  {
    id: 'hr-upcoming-holidays',
    label: 'List upcoming holidays',
    agent: 'hr',
  },
  {
    id: 'hr-profile',
    label: 'View my employee profile',
    agent: 'hr',
  },
  {
    id: 'hr-policy',
    label: 'Search policy documents',
    agent: 'hr',
  },
  {
    id: 'hr-grievances',
    label: 'View my grievances',
    agent: 'hr',
  },
  // ── HR: More Attendance & Time ────────────────────────────
  {
    id: 'hr-my-productivity',
    label: 'View my productivity summary',
    agent: 'hr',
  },
  {
    id: 'hr-late-logins-report',
    label: 'Show late logins this month',
    agent: 'hr',
  },
  {
    id: 'hr-missed-punches',
    label: 'Show missed clock-outs',
    agent: 'hr',
  },
  {
    id: 'hr-approve-regularisation',
    label: 'Approve a regularisation request',
    agent: 'hr',
  },

  // ── HR: More Leave ─────────────────────────────────────────
  {
    id: 'hr-approve-leave',
    label: 'Approve a leave request',
    agent: 'hr',
  },
  {
    id: 'hr-reject-leave',
    label: 'Reject a leave request',
    agent: 'hr',
  },
  {
    id: 'hr-leave-calendar',
    label: 'View the leave calendar',
    agent: 'hr',
  },
  {
    id: 'hr-employee-leave-history',
    label: "View an employee's leave history",
    agent: 'hr',
  },

  // ── HR: More Profile & Documents ───────────────────────────
  {
    id: 'hr-employee-profile-lookup',
    label: "Look up an employee's profile",
    agent: 'hr',
  },
  {
    id: 'hr-employee-documents-lookup',
    label: "View an employee's documents",
    agent: 'hr',
  },
  {
    id: 'hr-pending-edit-requests',
    label: 'Review pending profile edit requests',
    agent: 'hr',
  },
  {
    id: 'hr-high-risk-edit-requests',
    label: 'Show high-risk edit requests',
    agent: 'hr',
  },
  {
    id: 'hr-approve-edit-request',
    label: 'Approve a profile edit request',
    agent: 'hr',
  },

  // ── HR: More Grievances & Notifications ────────────────────
  {
    id: 'hr-open-grievances',
    label: 'Show open grievances',
    agent: 'hr',
  },
  {
    id: 'hr-critical-grievances',
    label: 'Show critical grievances',
    agent: 'hr',
  },
  {
    id: 'hr-resolve-grievance',
    label: 'Mark a grievance resolved',
    agent: 'hr',
  },
  {
    id: 'hr-unread-notifications',
    label: 'Show unread notifications',
    agent: 'hr',
  },
  {
    id: 'hr-mark-notification-read',
    label: 'Mark a notification as read',
    agent: 'hr',
  },

  // ── HR: More Onboarding ─────────────────────────────────────
  {
    id: 'hr-onboarding-lookup',
    label: "Check a new hire's onboarding status",
    agent: 'hr',
  },
  {
    id: 'hr-missing-onboarding-docs',
    label: 'Show missing onboarding documents',
    agent: 'hr',
  },

  // ── HR: More Team / Reports ──────────────────────────────────
  {
    id: 'hr-bottom-performers',
    label: 'Show employees needing attention',
    agent: 'hr',
  },
  {
    id: 'hr-department-headcount',
    label: 'View headcount by department',
    agent: 'hr',
  },
  {
    id: 'hr-inactive-slack-users',
    label: 'Show inactive employees on Slack',
    agent: 'hr',
  },
  {
    id: 'hr-attendance-rate-report',
    label: 'View company attendance rate',
    agent: 'hr',
  },

  // ── HR: More Admin / Ops ──────────────────────────────────────
  {
    id: 'hr-drive-folders',
    label: 'View Google Drive sync folders',
    agent: 'hr',
  },
  {
    id: 'hr-connect-slack',
    label: 'Check Slack connection status',
    agent: 'hr',
  },
  {
    id: 'hr-connect-drive',
    label: 'Check Google Drive connection status',
    agent: 'hr',
  },
  {
    id: 'hr-billing-plans',
    label: 'View available subscription plans',
    agent: 'hr',
  },
  {
    id: 'hr-billing-history',
    label: 'View billing history',
    agent: 'hr',
  },
  {
    id: 'hr-active-subscription',
    label: 'View current subscription',
    agent: 'hr',
  },
  {
    id: 'hr-total-spent',
    label: 'View total amount spent',
    agent: 'hr',
  },
  {
    id: 'hr-pending-deletion-requests',
    label: 'Show pending data deletion requests',
    agent: 'hr',
  },
  {
    id: 'hr-update-event',
    label: 'Reschedule a company event',
    agent: 'hr',
  },
  {
    id: 'hr-notifications',
    label: 'Check notifications',
    agent: 'hr',
  },
  {
    id: 'hr-onboarding',
    label: 'Check my onboarding status',
    agent: 'hr',
  },
  {
    id: 'recruiter-jobs',
    label: 'Show all jobs',
    agent: 'recruitment',
  },
  {
    id: 'recruiter-candidates',
    label: 'Show candidates',
    agent: 'recruitment',
  },
  {
    id: 'recruiter-draft-jd',
    label: 'Draft a job description',
    agent: 'recruitment',
  },
  {
    id: 'recruiter-schedule-interview',
    label: 'Schedule an interview',
    agent: 'recruitment',
  },
  {
    id: 'recruiter-intake-form',
    label: 'Get intake form for a job',
    agent: 'recruitment',
  },
  {
    id: 'recruiter-documents',
    label: 'Search job documents',
    agent: 'recruitment',
  },
  {
    id: 'recruiter-report',
    label: 'Generate recruitment report',
    agent: 'recruitment',
  },
  {
    id: 'recruiter-export',
    label: 'Export candidates',
    agent: 'recruitment',
  },
  {
    id: 'project-sprint',
    label: 'Create a sprint plan',
    agent: 'project',
  },
  {
    id: 'project-timeline',
    label: 'Show project timeline',
    agent: 'project',
  },
  {
    id: 'project-delegate',
    label: 'Delegate a task',
    agent: 'project',
  },
  {
    id: 'project-gantt',
    label: 'Generate Gantt chart',
    agent: 'project',
  },
  {
    id: 'project-update',
    label: 'Share a project update',
    agent: 'project',
  },
  {
    id: 'project-list',
    label: 'List all projects',
    agent: 'project',
  },
  {
    id: 'project-create',
    label: 'Create a new project',
    agent: 'project',
  },
  {
    id: 'project-progress',
    label: 'Check project progress',
    agent: 'project',
  },
  {
    id: 'project-pending',
    label: 'Show pending tasks',
    agent: 'project',
  },
  {
    id: 'project-milestone',
    label: 'Add a milestone',
    agent: 'project',
  },
  {
    id: 'project-deadline',
    label: 'Set project deadline',
    agent: 'project',
  },
  {
    id: 'project-team',
    label: 'List project team members',
    agent: 'project',
  },
  {
    id: 'project-budget',
    label: 'Track project budget',
    agent: 'project',
  },
  {
    id: 'project-status',
    label: 'Review project status',
    agent: 'project',
  },
  {
    id: 'project-risk',
    label: 'Identify project risks',
    agent: 'project',
  },
  {
    id: 'project-assign',
    label: 'Assign task to team member',
    agent: 'project',
  },
  {
    id: 'project-priority',
    label: 'Set task priority',
    agent: 'project',
  },
  {
    id: 'project-retro',
    label: 'Schedule retrospective',
    agent: 'project',
  },
  {
    id: 'project-standup',
    label: 'Log standup update',
    agent: 'project',
  },
  {
    id: 'project-blocker',
    label: 'Report a blocker',
    agent: 'project',
  },
  {
    id: 'project-dependency',
    label: 'Map task dependencies',
    agent: 'project',
  },
  {
    id: 'project-velocity',
    label: 'Check team velocity',
    agent: 'project',
  },
  {
    id: 'project-capacity',
    label: 'View team capacity',
    agent: 'project',
  },
  {
    id: 'project-archive',
    label: 'Archive completed project',
    agent: 'project',
  },
  {
    id: 'project-resource',
    label: 'Reallocate resources',
    agent: 'project',
  },
  {
    id: 'project-roadmap',
    label: 'Share product roadmap',
    agent: 'project',
  },
  {
    id: 'project-kpi',
    label: 'Review project KPIs',
    agent: 'project',
  },
  {
    id: 'project-meeting',
    label: 'Schedule project meeting',
    agent: 'project',
  },
  {
    id: 'project-complete',
    label: 'Mark task complete',
    agent: 'project',
  },
  {
    id: 'project-reopen',
    label: 'Reopen closed task',
    agent: 'project',
  },
  {
    id: 'project-merge',
    label: 'Merge feature branch',
    agent: 'project',
  },
  {
    id: 'project-deploy',
    label: 'Trigger deployment',
    agent: 'project',
  },
  {
    id: 'project-monitor',
    label: 'Monitor deployment status',
    agent: 'project',
  },
  {
    id: 'project-rollback',
    label: 'Rollback release',
    agent: 'project',
  },
  {
    id: 'project-env',
    label: 'Switch environment',
    agent: 'project',
  },
  {
    id: 'project-ci',
    label: 'Run CI pipeline',
    agent: 'project',
  },
  {
    id: 'project-bug',
    label: 'Log a bug',
    agent: 'project',
  },
  {
    id: 'project-feature',
    label: 'Request a feature',
    agent: 'project',
  },
  {
    id: 'project-stakeholder',
    label: 'Notify stakeholders',
    agent: 'project',
  },
  {
    id: 'project-doc',
    label: 'Update project docs',
    agent: 'project',
  },
];
